<div class="breadcrumbGlobal">
    <a [routerLink]="['/mydashboard']">
        <mat-icon>home</mat-icon>
    </a>
    <mat-icon>chevron_right</mat-icon>
    <span translate>MENU.UNIVERSITY</span>
</div>

<tb-header specificTitle="MENU.UNIVERSITY" parentPage="productsdownload"></tb-header>
<div class="contentGlobal">
  <div style="display: flex; justify-content: center; flex-wrap: wrap">
      <div>
          <ms-training-courses-card></ms-training-courses-card>
      </div>
      <div>
          <ms-training-plans-card></ms-training-plans-card>
      </div>
      <div *ngIf="false">
        <ms-favourites-courses-list></ms-favourites-courses-list>
    </div>
  </div>
</div>
